// src/utils/sales/saleDates.js
// Date conversion for <input type="date"> fields on sales forms.
//
// Both directions work in local time on purpose. Reading a date with
// toISOString() and writing it back with new Date('yyyy-mm-dd') both cross into
// UTC, which shifts a sale by a day for anyone west of Greenwich.

/**
 * Converts a stored date into the yyyy-mm-dd string a date input expects.
 * @param {Date|string|Object} value - Date, ISO string, or Firestore Timestamp
 * @returns {string} Local calendar date, or '' when there is no usable date
 */
export const toDateInputValue = (value) => {
  if (!value) return '';

  const date = typeof value?.toDate === 'function' ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

/**
 * Converts a date input's yyyy-mm-dd string into local midnight.
 * @param {string} value - Value from a date input
 * @returns {Date|null}
 */
export const fromDateInputValue = (value) => {
  if (!value) return null;

  const [year, month, day] = String(value).split('-').map(Number);
  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day);
};
